export default __webpack_public_path__ + "static/media/members_.3a94a028.png";